<div class="option">
  <p class="title">{{ name }}</p>
  <div class="items">
    @for (item of allItems; track item.name) {
      <div class="item">
        <mat-checkbox
          [checked]="isSelected(item)"
          [disabled]="!editMode"
          (change)="handleClickOnCheckboxElement(item)">
          {{ getTranslation(item.name) }}
        </mat-checkbox>
        <div>
          <mat-icon
            (click)="handleClickOnIcons(item, 'charged')"
            onkeypress="handleClickOnIcons(item, 'charged')"
          [style.color]="
            isSelected(item)
              ? isCharged(item)
                ? '#cf741a'
                : 'grey'
              : 'lightgrey'
          "
            [style.cursor]="isSelected(item) ? 'pointer' : 'not-allowed'"
            >euro</mat-icon
            >
            <mat-icon
              (click)="handleClickOnIcons(item, 'locked')"
              onkeypress="handleClickOnIcons(item, 'locked')"
          [style.color]="
            isSelected(item)
              ? isLocked(item)
                ? '#cf741a'
                : 'grey'
              : 'lightgrey'
          "
              [style.cursor]="isSelected(item) ? 'pointer' : 'not-allowed'"
              >lock</mat-icon
              >
            </div>
          </div>
        }
      </div>
    </div>
